import { Twitter, Send, Rocket, FileSearch, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { useLanguage } from "@/i18n/LanguageContext";
import { projectConfig, isUrlSet, explorerTokenUrl } from "@/config/project";

export default function Community() {
  const { t } = useLanguage();

  // Only channels with a configured URL are rendered — placeholders stay hidden.
  const channels = [
    isUrlSet(projectConfig.twitterUrl) && {
      id: "community-link-x",
      icon: Twitter,
      name: t("community.cards.x.name"),
      desc: t("community.cards.x.desc"),
      href: projectConfig.twitterUrl,
    },
    isUrlSet(projectConfig.telegramUrl) && {
      id: "community-link-telegram",
      icon: Send,
      name: t("community.cards.telegram.name"),
      desc: t("community.cards.telegram.desc"),
      href: projectConfig.telegramUrl,
    },
    isUrlSet(projectConfig.fourMemeUrl) && {
      id: "community-link-four-meme",
      icon: Rocket,
      name: t("community.cards.fourMeme.name"),
      desc: t("community.cards.fourMeme.desc"),
      href: projectConfig.fourMemeUrl,
    },
    {
      id: "community-link-bscscan",
      icon: FileSearch,
      name: t("community.cards.bscscan.name"),
      desc: t("community.cards.bscscan.desc"),
      href: explorerTokenUrl,
    },
  ].filter(Boolean);

  return (
    <section id="community" className="scroll-mt-24 bg-[#0D0608] px-4 py-24 sm:px-6 lg:px-8" data-testid="community-section">
      <div className="mx-auto max-w-7xl">
        <SectionHeader kicker={t("community.kicker")} title={t("community.title")} id="community" />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.id} delay={0.06 * i}>
                <a
                  href={c.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={c.id}
                  className="group flex h-full flex-col rounded-xl border border-red-900/30 bg-[#140A0D] p-6 transition-all hover:-translate-y-1 hover:border-yellow-700/60"
                >
                  <div className="mb-5 flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-red-950/60 text-red-400 transition-colors group-hover:text-yellow-400">
                      <Icon size={20} aria-hidden="true" />
                    </span>
                    <ArrowUpRight size={17} className="text-zinc-600 transition-colors group-hover:text-yellow-500" aria-hidden="true" />
                  </div>
                  <h3 className="mb-1.5 text-base font-bold text-zinc-100">{c.name}</h3>
                  <p className="text-sm leading-relaxed text-zinc-400">{c.desc}</p>
                </a>
              </Reveal>
            );
          })}
        </div>
        {channels.length < 4 && (
          <Reveal delay={0.12}>
            <p className="mt-8 text-xs leading-relaxed text-zinc-500" data-testid="community-pending-note">
              {t("community.pending")}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
